<template>
  <!-- 查重、校对 -->
  <div class="check">
    <div class="check_box">
      <div class="title">
        <h2 style="text-align: center; font-size: 25px">
          Writeful语法检查系统
        </h2>
      </div>
      <div class="describes">
        <ProoWriteful
          style="width: 1200px"
          @checkup="open"
          v-if="detects"
        ></ProoWriteful>
      </div>
      <div class="check_again" v-if="checkAgain">
        <div class="prompt">
          <el-steps :active="3">
            <el-step title="上传文件" icon="el-icon-upload"></el-step>
            <el-step title="进行校对" icon="el-icon-data-analysis"></el-step>
            <el-step title="生成报告" icon="el-icon-tickets"></el-step>
          </el-steps>
          <div class="prompt_text">
            <span class="arrow">支持</span><i class="el-icon-arrow-right"></i
            ><span class="text"
              >外语毕业论文、留学生作业、SCI\EI\ACS等期刊、职称论文<span
                style="font-size: 10px; color: red"
                >（仅限英文文章）</span
              >校对，对语言运用有要求的文字均可使用本系统</span
            >
          </div>
          <div class="prompt_text">
            <span class="arrow">说明</span><i class="el-icon-arrow-right"></i
            ><span class="text"
              >论文引用内容和参考文献不在校对范围内，为保证报告精准度请提交论文正文</span
            >
          </div>
          <div class="prompt_text">
            <span class="arrow">有效期</span><i class="el-icon-arrow-right"></i
            ><span class="text"
              >报告在平台保留一周，并且在一周内适用于多次下载报告使用</span
            >
          </div>
          <!-- <img style="width: 100%" src="../../../assets/imgs/上传.png" alt="" /> -->
        </div>
        <div class="upLoad">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            name="file"
            :data="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
            id="uploadForm"
          >
            <!-- <el-form-item label="文章标题" prop="title">
            <el-input v-model="ruleForm.title"></el-input>
          </el-form-item>
          <el-form-item label="文章作者" prop="author">
            <el-input v-model="ruleForm.author"></el-input>
          </el-form-item>
          <el-form-item label="检测类型" prop="task_type">
            <el-radio-group v-model="ruleForm.task_type">
              <el-radio :label="0">英文查重</el-radio>
              <el-radio :label="1">语法校对</el-radio>
            </el-radio-group>
          </el-form-item> -->
            <!-- <el-form-item label="文件上传" prop="file"> -->
            <div class="usage">当前账号剩余使用量：{{ usages }}</div>
            <div class="upDemo" v-if="isRouterAlive">
              <el-upload
                class="upload-demo"
                id="uploadForm"
                drag
                ref="file"
                :action="actionUrl"
                :headers="{ token: token }"
                :before-upload="beforeUpload"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :on-change="on_change"
                :before-remove="beforeRemove"
                multiple
                :limit="1"
                :on-exceed="handleExceed"
                :auto-upload="false"
                :file-list="fileList"
              >
                <div class="upStyle">
                  <div style="margin: 0 0 20px 50px">
                    <div style="">
                      <i
                        class="el-icon-upload"
                        style="
                          font-size: 67px;
                          color: #c0c4cc;
                          line-height: 50px;
                        "
                      ></i>
                      <div class="el-upload__text">
                        <em style="font-style: normal">点击上传</em>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="el-upload__tip" slot="tip">只能上传txt/docx/pdf文件</div> -->
              </el-upload>
              <div class="upload_tip">
                <!-- <img src="../../../assets/imgs/查重与校对/上传要求01.png" alt="" /> -->
                <img
                  class="upload_tip_img"
                  src="../../../assets/imgs/tip.307c8b1.png"
                  alt=""
                />
                <div class="upload_tip_text">
                  <!-- <p class="upload_tip_p">
                    文档大小必须小于 30 MB
                  </p> -->
                  <p class="upload_tip_p">
                    文档大小必须小于10万字符， 4 MB大小
                  </p>

                  <p class="upload_tip_p">
                      文档必须有至少 100 个字符的内容</p>

                  <p class="upload_tip_p">
                    文件上传仅限于支持txt、docx、doc格式文件
                    <br />
                  </p>
                  <!-- <p class="upload_tip_p">
                    文件上传仅限于支持txt、doc、docx格式文件, 图片不校对。
                    <br />
                  </p> -->
                  <!-- <p class="upload_tip_p">
                    上传前请清除文档内中文, 图片, 批注及其他不需要查重的内容。
                  </p> -->
                  <p class="upload_tip_p">
                    上传前请清除文档内中文, 图片, 批注及其他不需要校对的内容。
                  </p>
                  <p class="upload_tip_p">
                    docx格式文件上传前请取消docx文档内的修订（
                    <span class="hovers" @click="link">取消方法</span> ）。
                  </p>
                </div>
              </div>
            </div>
            <!-- </el-form-item>
          <el-form-item> -->
            <div class="btn">
              <el-button type="primary" @click="submitForm()" :loading="returns"
                >提&emsp;交</el-button
              >
            </div>
            <!-- </el-form-item> -->
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Proofreading from "./Dtect/proofreading.vue";
import store from "@/store";
import { checks } from "@/Api/checkAgain";
import $ from "jquery";
import qs from "qs";
import { Message } from "element-ui";
import ProoWriteful from "./Dtect/prooWriteful.vue";
import {
  detail_list,
  input_file,
  download,
  get_limit,
} from "@/Api/scholarcy_writeful01";
export default {
  inject: ["reloading"],
  provide() {
    return {
      reloadProof: this.reloadProof,
      // Height: 0,
    };
  },
  data() {
    return {
      actionUrl: "https://scholary.newacademic.net/api/qingli/writ/input_file",
      token: localStorage.getItem("token"),
      ruleForm: {
        title: "",
        author: "",
        task_type: null,
        file: "",
      },
      rules: {
        // title: [{ required: true, message: "请输入文章标题", trigger: "blur" }],
        // author: [
        //   { required: true, message: "请输入文章作者", trigger: "blur" },
        // ],
        // task_type: [
        //   { required: true, message: "请选择检测类型", trigger: "change" },
        // ],
        file: [
          { required: true, message: "请选择文件上传", trigger: "change" },
        ],
      },
      fileList: [],
      checkAgain: false,
      detects: true,
      isRouterAlive: true,
      returns: false,
      usages: 0,
      filename_up:"",
    };
  },
  mounted() {
    this.getUsage();
  },
  methods: {
    // 打开查重
    open(data) {
      // console.log(data)
      if (data == "true") {
        this.checkAgain = true;
        this.detects = false;
      }
    },
    getUsage() {
      let limit_ids = {
        open_id: localStorage.getItem("code"),
      };
      get_limit(limit_ids)
        .then((res) => {
        //   console.log(res);
          this.usages = res.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleRemove(file, fileList) {
      // console.log(file, fileList);
    },
    handlePreview(file) {
      // console.log(file);
    },
    // 上传前处理
    beforeUpload(file) {
      // let fileSize = file.size;
      // const FIVE_M = 5 * 1024 * 1024;
      // //大于5M，不允许上传
      // if (fileSize > FIVE_M) {
      //   this.$message.error("最大上传5M");
      //   return false;
      // }
      //判断文件类型，必须是xlsx格式
      // let fileName = file.name;
      // let reg = /^.+(\.xlsx)$/;
      // if (!reg.test(fileName)) {
      //   this.$message.error("只能上传xlsx!");
      //   return false;
      // }
      // return true;
    },
    on_change(file, fileList) {
      console.log(file, fileList);
      let fileName = file.name;
      this.filename_up = file.name;
      let reg = /^.+(\.doc)$/;
      let reg01 = /^.+(\.docx)$/;
      let reg02 = /^.+(\.txt)$/;
      if (
        !reg.test(fileName) &&
        !reg01.test(fileName) &&
        !reg02.test(fileName)
      ) {
        this.$message.error("只能上传doc , docx  , txt 格式文件!");
        this.fileList = [];
        return false;
      } else {
        this.ruleForm.file = file;
        this.fileList = fileList;
      }
    },

    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    reloadProof() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    // 确认上传
    submitForm(formName) {
     
      // console.log("aa")
      // var formData = new FormData($("#uploadForm")[0]);
      // var formData = new FormData($("#uploadForm")[0]);
      // console.log(formData)
      // this.$refs.uploadFile2是vue中获取dom元素的方法
      // 通过files就可以拿到所有上传的文件，如果是多个文件循环即可
      // formData.append("file", this.$refs.uploadFile2.files[0]);
      // 必须设置请求类型
      // formData.append("title", this.ruleForm.title);
      // 如果需要传id的情况下，参考下面代码
      // formData.append("author", this.ruleForm.author);
      
      if (this.fileList.length > 0) {
        var formData = new FormData();
        formData.append("input_file", this.fileList[0].raw);
      } else {
        var formData = new FormData($("#uploadForm")[0]);
        this.$message.error('请上传文件')
        return
      }
      if(this.fileList[0].size > 31457280){
        this.$message.error('文件过大，请更换文件重试')
        this.returns = false
        this.fileList = []
        return
      }
      this.returns = true;
      //   formData.append("is_tran", 0);
      formData.append("open_id", localStorage.getItem("code"));
      formData.append("organ_name", localStorage.getItem("org_name"));
      formData.append("filename", this.filename_up);
    //   console.log(formData);
    //   return
      // checks(formData)
      //   .then((res) => {
      //     console.log(res);
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //   });
      // var formData = this.ruleForm;
      let that = this;
      $.ajax({
        url: "https://scholary.newacademic.net/api/qingli/writ/input_file",
        type: "POST",
        cache: false,
        data: formData,
        processData: false,
        contentType: false,
        headers: {
          // "Content-Type": "application/x-www-form-urlencoded",
          token: localStorage.getItem("token"),
          // Token:"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE2NDE5NzQ4OTAsImlhdCI6MTY0MTM3MDA4MCwiZGF0YSI6eyJpZCI6MTY0LCJlbWFpbCI6IjEwMTM3MTU0NzNAcXEuY29tIiwicGhvbmUiOiIxODR4eHh4MDYwNyIsIm5hbWUiOiJcdTVmOTBcdTU2MDlcdTY1NGYiLCJmYWN1bHR5IjoiXHU1ZjAwXHU1M2QxIiwic3RhdHVzIjowfX0.629NEWBqMr2-unocUDSScxUQAhr0G3HgitzdnM4hw7E",
        },
      })
        .done(function (res) {
          console.log(res);
          //
          that.fileList = [];
          if (res.code == 200) {
            Message({
              message: res.message + ",请在  查看报告  中浏览",
              type: "success",
            });
          } else {
            Message.error(res.message);
            that.returns = false;
          }
          // this.returns = false;
        })
        .fail(function (res) {
          Message.error("提交失败！！请稍后再试！");
          // this.returns = false;
        });
      that.reloadProof();
      setTimeout(() => {
        that.returns = false;
      }, 1000);
      // this.$refs[formName].validate((valid) => {
      //   if (valid) {
      //     // console.log(this.ruleForm);

      //   } else {
      //     console.log("error submit!!");
      //     return false;
      //   }
      // });
    },
    link() {
      window.open(
        "https://support.microsoft.com/en-us/office/accept-tracked-changes-4838d24c-d5d1-4c6c-8e39-78b44bd2b4cc?ui=en-us&rs=en-us&ad=us",
        "_blank"
      );
    },
  },
  components: {
    Proofreading,
    ProoWriteful,
  },
};
</script>

<style lang='less' scoped>
.check {
  min-height: calc(100vh - 180px);
  min-width: 1100px;
  // overflow-x: hidden;
  // overflow-y: scroll;
  background: white;
  padding: 30px 10%;
  display: flex;
  justify-content: center;
  .check_box {
    // width: 1000px;
    width: 1200px;
    min-width: 1100px;
    .prompt {
      // margin: 0 20%;
      .el-steps {
        margin: 20px 50px;
        color: goldenrod !important;
        /deep/ .el-step__head {
          color: #303133;
          border-color: #303133;
        }
        /deep/ .el-step__title {
          color: #303133;
          font-size: 20px;
        }
        /deep/ .el-step__icon-inner {
          font-size: 30px;
          margin: 0 5px;
        }
      }
      .prompt_text {
        margin: 5px 50px;
        display: flex;
        .arrow {
          display: inline-block;
          width: 80px;
          height: 40px;
          line-height: 32px;
          text-align: center;
          border: 3px solid rgb(207, 207, 207);
          border-right: none;
          color: rgb(107, 107, 107);
          font-size: 18px;
        }
        i {
          display: inline-block;
          font-size: 55px;
          position: relative;
          top: -7px;
          left: -20px;
          font-weight: lighter;
          color: rgb(207, 207, 207);
        }
        .text {
          line-height: 40px;
          display: inline-block;
          font-size: 17px;
        }
      }
    }
    .upLoad {
      .el-input {
        width: 360px;
      }
      .btn {
        width: 100%;
        margin-top: 30px;
        display: flex;
        justify-content: center;
        .el-button {
          width: 120px;
          font-size: 16px;
        }
      }
      .upDemo {
        width: calc(100% - 100px);
        // min-width: 920px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        margin: 0 45px;
        border: 1px rgb(139, 139, 139) dashed;
        border-radius: 5px;
        .upload-demo {
          // width: 920px;
          // margin: 0 40px;
          /deep/ .el-upload {
            // width: 100%;
            .el-upload-dragger {
              // width: 100%;
              // height: 300px;
              border: none;
              .upStyle {
                // display: flex;
                // justify-content: space-between;
              }
            }
          }
        }
      }
    }
  }
}
.describes {
  display: flex;
  justify-content: center;
}
.upload_tip {
  position: relative;
  margin: 50px 0 30px 0;
  background-color: #f0f7fd;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.25);
  cursor: pointer;

  .upload_tip_img {
    position: absolute;
    left: 50%;
    top: -50px;
    width: 100px;
    height: 100px;
    transform: translateX(-50%);
  }
  .upload_tip_title {
    font-size: 13px;
    color: red;
  }
  .upload_tip_text {
    margin-top: 16px;
    padding: 20px;
  }
  .upload_tip_p {
    margin-bottom: 4px;
    line-height: 1.5;
    color: #777;
  }
  .upload_tip_p::before {
    content: "";
    display: inline-block;
    width: 5px;
    height: 5px;
    margin-right: 10px;
    border-radius: 50%;
    vertical-align: middle;
    background-color: #666;
  }
}
.hovers {
  color: rgb(245, 135, 135);
}
.hovers:hover {
  color: rgb(94, 177, 245);
}
.usage {
  margin: 10px 50px 30px 50px;
  font-size: 18px;
  // color: rgb(138, 71, 247);
}
</style>